<template>
  <div>
    <v-container>
      <v-layout row wrap justify-space-between>
        <v-flex xs2>
          <choice-list :config="interfaceConfig"></choice-list>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model="coreClock"
            label="Core Clock Speed"
            suffix="Mhz"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model="memory"
            label="Memory"
            suffix="GB"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model="bandwidth"
            label="Bandwidth"
            suffix="GB/s"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <standard-actions
      @save="save"
      @cancel="cancel"
      @close="$emit('close')"
      :save-button="{ name: 'Submit', disabled: !canProceed }"
      :cancel-button="{ name: 'Back' }"
    ></standard-actions>
  </div>
</template>

<script>
import standardActions from '../standardActions'
import choices from '../../autocompletes/choices'

export default {
  name: 'storage',
  components: {
    'standard-actions': standardActions,
    'choice-list': choices
  },
  computed: {
    canProceed () {
      return this.interfaceConfig.id && this.coreClock > 0 && this.memory > 0 && this.bandwidth > 0
    }
  },
  data () {
    return {
      interfaceConfig: {
        id: 0,
        label: 'Interface',
        appName: 'parts',
        modelName: 'gpu',
        fieldName: 'interface'
      },

      coreClock: null,
      memory: null,
      bandwidth: null
    }
  },
  methods: {
    save () {
      const details = {
        interface: this.interfaceConfig.id,
        core_clock_mhz: this.coreClock,
        memory_mb: this.memory,
        memory_bandwidth_mbps: this.bandwidth
      }
      this.$emit('save', details)
    },

    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
